import React from "react";
import { ActionIcon, Group } from "@mantine/core";
import { IconEdit, IconTrash } from "@tabler/icons-react";
import { DiscountPreset } from "../../../types/discounts";
import styles from "./DiscountPresetsSettings.module.css";

export interface DiscountPresetActionsProps {
  preset: DiscountPreset;
  /** Show Edit (requires settingsDiscounts.canManagePresets). */
  canEdit: boolean;
  /** Show Delete (requires settingsDiscounts.canDeletePresets). */
  canDelete: boolean;
  onEdit: (preset: DiscountPreset) => void;
  onDelete: (preset: DiscountPreset) => void;
}

/**
 * The permission-gated Edit / Delete icon pair shared by the desktop table row
 * and the phone card, with ≥44px touch targets. Renders nothing when the user
 * can do neither.
 */
export default function DiscountPresetActions({
  preset,
  canEdit,
  canDelete,
  onEdit,
  onDelete,
}: DiscountPresetActionsProps) {
  if (!canEdit && !canDelete) return null;
  return (
    <Group gap={4} wrap="nowrap">
      {canEdit && (
        <ActionIcon
          variant="subtle"
          color="teal"
          size="lg"
          className={styles.touchTarget}
          aria-label={`Edit ${preset.name}`}
          onClick={() => onEdit(preset)}
        >
          <IconEdit size={18} />
        </ActionIcon>
      )}
      {canDelete && (
        <ActionIcon
          variant="subtle"
          color="var(--color-danger)"
          size="lg"
          className={styles.touchTarget}
          aria-label={`Delete ${preset.name}`}
          onClick={() => onDelete(preset)}
        >
          <IconTrash size={18} />
        </ActionIcon>
      )}
    </Group>
  );
}
